/**
 * Heat input conversion functions.
 *
 * Section 3.4.2.18.
 */
export const convertHeatInput = {
  /**
   * Convert to weld machine format.
   *
   * 1.75 kJ/mm => 175
   *
   * @param heatInput Heat input in kJ/mm.
   * @returns Weld machine format.
   */
  toWeldMachine: (heatInput: number) => Math.round(heatInput * 100),

  /**
   * Convert from weld machine format.
   *
   * 175 => 1.75 kJ/mm
   *
   * @param received Weld machine format.
   * @returns Heat input in kJ/mm.
   */
  fromWeldMachine: (received: number) => received / 100,
};
